import React, { useContext } from 'react'
import { LocaleContext } from '../routes'
import Radio from './common/Radio'
import { LabelExtra } from '../styles/elements'
import { Gender } from '../styles/register'
import { RadioWrapper } from '../styles/radio'

export default ({ onChange, isMale }) => {
  const locale = useContext(LocaleContext)

  return (
    <Gender>
      <LabelExtra>{locale.GENDER}</LabelExtra>
      <RadioWrapper>
        <Radio name="gender" value={isMale == null ? false : isMale} onChange={onChange} label={locale.FEMALE} />
        <Radio name="gender" value={isMale == null ? true : isMale} onChange={onChange} label={locale.MALE} />
      </RadioWrapper>
    </Gender>
  )
}